import { SaveFormResult } from "../../../components/Posts/PostForm/types";
import { FormSaveCallback } from "./bulk-create-post.types";

export class BulkCreatePostActiveContext {
  private formSavedMap = new Map<string, SaveFormResult>();
  private formSaveCallbackMap = new Map<string, FormSaveCallback>();
  notifyFormSaved(id: string, result: SaveFormResult) {
    this.formSavedMap.set(id, result);
  }

  registerFormSaveCallback(id: string, callback: FormSaveCallback) {
    this.formSaveCallbackMap.set(id, callback);
  }

  getFormSaveCallback(id: string): FormSaveCallback | undefined {
    return this.formSaveCallbackMap.get(id);
  }

  isAnyFormSaved(): boolean {
    return [...this.formSavedMap.values()].some(Boolean);
  }
  getAllSavedForms(): SaveFormResult[] {
    return [...this.formSavedMap.values()].filter(Boolean) as SaveFormResult[];
  }
}

class Manager {
  private activeContext: BulkCreatePostActiveContext | undefined;
  getActive() {
    if (!this.activeContext) {
      this.activeContext = new BulkCreatePostActiveContext();
    }
    return this.activeContext;
  }
  newActiveContext() {
    this.activeContext = new BulkCreatePostActiveContext();
    return this.activeContext;
  }
}

export const bulkCreatePostContextManager = new Manager();
